<template>
  <v-flex pa-3>
    <h2>Confirmar modifiación</h2>
    <v-flex class="container-info" mt-3 px-3 pt-2>
      <v-flex>
        <p class="mt-1">¿Está seguro que desea modificar la misión según los datos ingresados?</p>
      </v-flex>      
      <v-flex style="margin-top:-20px;">
        <v-checkbox
          v-model="agreeAction"
          label="Si"
          @change="changeAction"
        />
      </v-flex>
    </v-flex>
    <!-- JUSTIFICATION -->
    <v-flex v-if="agreeAction" mt-2>
      <p>¿Por qué se modifica la misión?</p>
      <!-- TEXT AREA -->
      <!-- :disabled="disabledCancel" -->
      <!-- @input="textInputAction"÷ -->
      <v-textarea
        v-model="observationInput"
        box
        name="observations"
        label="Justificación"
        @input="textInputAction"
      ></v-textarea>
      <!-- ACTION BUTTON -->
      <v-flex d-flex>
        <v-btn
          color="primary"
          :disabled="justificationComputed"
          @click="modifyMissionIn"
          :loading="$loading.isLoading('modifyingMission')"
        >
          <v-icon left>edit</v-icon>
          Modificar Misión
        </v-btn>
      </v-flex>
    </v-flex>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex'

import { missionInProgressMixin } from '../../../mixins/missionInProgressMixin'

export default {
  name: 'modify-mission-final',
  mixins: [missionInProgressMixin],
  props: [
    'itemSelected',
    'optionSelected',
    'dataToUpdate',
    'startDateCurrent',
    'startTimeCurrent',
    'futureMission'
  ],
  data() {
    return {
      observationInput: '',
      agreeAction: false
    }
  },
  computed: {
    justificationComputed() {
      let result = true
      if (!this.agreeAction) result = false
      else if (this.agreeAction && this.observationInput !== '') result = false
      return result
    }
  },
  methods: {
    ...mapActions([
      'modifyWhereMission',
      'modifyDatesMission',
      'modifyVehiclesMission'
    ]),
    validateWhenBeforeContinue() {
      let result = false
      const nowDateTime = this.$moment.now()
      const currentDateTime = this.$moment(nowDateTime).format('YYYY-MM-DD HH:mm')
      const currentMissionStartDateTime = `${this.startDateCurrent} ${this.startTimeCurrent}`
      // Validate if the mission has started
      if (this.$moment(currentDateTime).isAfter(currentMissionStartDateTime)) return result

      // Validate if the modifiyed Start Date and Time is X minutes before now
      const pastDateTime = this.$moment(nowDateTime).subtract(15, 'minute')
      const modifyedStartDateTime = `${this.dataToUpdate.dates.start} ${this.dataToUpdate.time.start}`
      result = !this.$moment(modifyedStartDateTime).isBefore(pastDateTime)
      // console.log('isBefore IN', result)
      return result
    },
    async modifyMissionIn() {
      // console.log('MODIFY MISSION', this.itemSelected.missionID)
      let response
      switch (this.optionSelected) {
        case 0: // WHO
          response = await this.modifyVehiclesMission({
            id: this.itemSelected.missionID,
            vehicles: this.dataToUpdate,
            modifiedWhy: this.observationInput
          })
          // console.log('modifyMissionIn -modifyVehiclesMission- WHO RESPONSE', response)
          if (response.data.success) {
            this.$emit('finishAction')
          } else {
            this.$emit('close')
            // this.$emit('showMessage')
          }
          this.observationInput = ''
          this.agreeAction = false
          break
        case 1: // WHERE
          response = await this.modifyWhereMission({
            id: this.itemSelected.missionID,
            where: this.dataToUpdate,
            modifiedWhy: this.observationInput
          })
          // console.log('modifyMissionIn -modifyWhereMission- WHERE RESPONSE', response)
          if (response.data.success) {
            this.$emit('finishAction')
          } else {
            this.$emit('close')
            // this.$emit('showMessage')
          }
          this.observationInput = ''
          this.agreeAction = false
          break
        case 2: // WHEN
          if (this.futureMission) {
            if (!this.validateWhenBeforeContinue()) {
              this.$emit('showMessage')
              this.$emit('close')
              break
            }
          }
          response = await this.modifyDatesMission({
            id: this.itemSelected.missionID,
            when: this.dataToUpdate,
            modifiedWhy: this.observationInput
          })
          // console.log('modifyMissionIn -modifyDatesMission- WHEN RESPONSE', response)
          if (response.data.success) {
            this.$emit('finishAction')
          } else {
            this.$emit('close')
            // this.$emit('showMessage')
          }
          this.observationInput = ''
          this.agreeAction = false
          break

        default:
          break
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.container-info
  background-color #616161
  border-radius 5px

</style>



// WEBPACK FOOTER //
// src/components/Missions/ActionsMissions/ModifyMissionFinal.vue